import { Link } from "@mui/material";
import { SnackbarQueueContext } from "contexts/SnackbarQueueContext";
import { usePostAppendToCase } from "hooks/alerts/usePostAppendToCase";
import PropTypes from "prop-types";
import React, { useContext, useMemo } from "react";
import { styled } from "@mui/material/styles";
import { ExistingCaseFormDialog } from "components/AlertsManagement/Case/form/ExistingCaseFormDialog";

export const AddToExistingCaseDialog = ({
  open,
  onClose,
  alert,
  onCaseCreateSuccess
}) => {
  const {
    alert_id: alertId,
    machine_id: machineId,
    component_id: componentId,
    tag_id: tagId,
    tag_name: tagName,
    tag_unit: tagUnit,
    rule_id: ruleId,
    rule_name: ruleName,
    severity_type_name: severityTypeName,
    severity_type_id: severityTypeId,
    recommendation
  } = alert;

  const { addSnackbarToQueue } = useContext(SnackbarQueueContext);

  const { loading, error, postAppendToCaseCallback } = usePostAppendToCase(
    alertId
  );

  const handleSuccessfulAppend = response => {
    onClose();
    onCaseCreateSuccess();
    addSnackbarToQueue({
      severity: "success",
      message: (
        <SnackbarContent>
          Alert successfully added to the Case
          <Link
            href={`/pages/case-management/${response.case}`}
            color="inherit"
            underline="always"
            target="_blank"
            rel="noopener noreferrer"
          >
            View Case
          </Link>
        </SnackbarContent>
      )
    });
  };

  const handleSubmit = values => {
    postAppendToCaseCallback({
      ...values.diagnostic,
      case: values.case.id,
      component: componentId,
      date_time: values.diagnostic.date_time.toISOString()
    }).then(handleSuccessfulAppend, _error => {});
  };

  const initialValues = useMemo(() => {
    return {
      case: null,
      description: `Rule ${ruleName} moved to ${severityTypeName}`,
      recommendation: recommendation ?? "",
      diagnostic: {
        date_time: new Date(),
        type: 1,
        case: null,
        case_severity_type: severityTypeId,
        description: `Rule ${ruleName} moved to ${severityTypeName}`,
        params: {
          feedComment: [],
          alertTimeSeriesMetadata: {
            tagId,
            tagName,
            tagUnit,
            machineId,
            severityTypeId,
            ruleId,
            ruleName
          }
        }
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [alert]);

  return (
    <ExistingCaseFormDialog
      open={open}
      machineId={machineId}
      loading={loading}
      error={error}
      onClose={onClose}
      initialValues={initialValues}
      onSubmit={handleSubmit}
    />
  );
};

AddToExistingCaseDialog.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  alert: PropTypes.object,
  onCaseCreateSuccess: PropTypes.func
};

const SnackbarContent = styled("div")`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing(2)};
`;
